export default {
  sm: `
   국내 최대 규모의 하이퍼스케일 데이터센터 
   각 세종은 클라우드 기반의 첨단기술을 통해
   미래 데이터 산업을 이끌어 갑니다.
  `,
  md: `
    국내 최대 규모의 하이퍼스케일 데이터센터 각 세종은
    클라우드 기반의 첨단기술을 통해 미래 데이터 산업을 이끌어 갑니다.
  `,
  lg: `
    국내 최대 규모의 하이퍼스케일 데이터센터 각 세종은
    클라우드 기반의 첨단기술을 통해 미래 데이터 산업을 이끌어 갑니다.
  `,
  xl: `
    국내 최대 규모의 하이퍼스케일 데이터센터 각 세종은
    클라우드 기반의 첨단기술을 통해 미래 데이터 산업을 이끌어 갑니다.
  `
};
